import * as React from 'react';
import * as turf from '@turf/turf';
const getStandsBBox = (stands) => {
    const standsGeoJSON = {
        type: 'FeatureCollection',
        features: stands.map(stand => stand.geoJSON),
    };
    return turf.bbox(standsGeoJSON);
};
const useMapFitBoundsAndSave = (map, stands, localStorageKey, fitBoundsOnInit = true) => {
    // when map or stands changes, zoom to new bounds
    React.useEffect(() => {
        if (!map)
            return;
        if (fitBoundsOnInit) {
            const savedBBoxStr = localStorage.getItem(localStorageKey);
            const bbox = savedBBoxStr
                ? JSON.parse(savedBBoxStr)
                : stands.length > 0
                    ? getStandsBBox(stands)
                    : undefined;
            if (bbox) {
                map.fitBounds(bbox, { duration: 0 });
            }
        }
        const setMapCoords = () => {
            localStorage.setItem(localStorageKey, JSON.stringify(map.getBounds().toArray()));
        };
        map.on('move', setMapCoords);
        return () => { map.off('move', setMapCoords); };
    }, [map, stands]);
    const fitBoundsToStands = (stands) => {
        const bbox = getStandsBBox(stands);
        map === null || map === void 0 ? void 0 : map.fitBounds(bbox, { duration: 500 });
    };
    return { fitBoundsToStands };
};
export default useMapFitBoundsAndSave;
